"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var ga_1 = require("../../../app/util/ga");
var actions_1 = __importDefault(require("../../actions"));
var fullScreenDialog_1 = __importDefault(require("../../../user/helpers/fullScreenDialog"));
var CopyIcon_1 = __importDefault(require("../../widgets/CopyIcon"));
var actions_2 = __importDefault(require("../../../app/components/pages/RootPage/actions"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        headerText: {
            marginTop: theme.spacing(3),
        },
        modalWrapper: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            marginLeft: theme.spacing(3),
            marginRight: theme.spacing(3),
        },
        copyApiKeyButton: {
            alignSelf: 'center',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
            paddingLeft: theme.spacing(10),
            paddingRight: theme.spacing(10),
            color: 'white',
            background: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
        apiKeyTextField: {
            marginTop: theme.spacing(2),
            width: '100%',
        },
        apiKeyTextInput: {
            paddingRight: theme.spacing(0.5),
        },
        copyButton: (_a = {
                padding: theme.spacing(0.75)
            },
            _a[theme.breakpoints.up('md')] = {
                padding: theme.spacing(1.5),
            },
            _a),
    });
});
var ApiKeyModal = function () {
    var isFullScreenDialog = (0, fullScreenDialog_1.default)();
    var classes = useStyles({ isFullScreenDialog: isFullScreenDialog });
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.api; }), apiKeyModal = _a.apiKeyModal, apiKey = _a.apiKey;
    var dispatch = (0, react_redux_1.useDispatch)();
    var closeApiKeyModal = function () { return dispatch(actions_1.default.closeApiKeyModal()); };
    (0, react_1.useEffect)(function () {
        if (apiKeyModal) {
            (0, ga_1.GAPageView)('API KEY VIEW PAGE');
            (0, ga_1.GAEvent)('api page', 'api key view page');
            return function () {
                (0, ga_1.GAPageView)('API PAGE');
            };
        }
        return undefined;
    }, [apiKeyModal]);
    return (react_1.default.createElement(core_1.Dialog, { "aria-labelledby": "apiKeyModal", "aria-describedby": "api-key-modal", fullScreen: false, fullWidth: true, maxWidth: "sm", onClose: closeApiKeyModal, open: apiKeyModal },
        react_1.default.createElement("div", { className: classes.modalWrapper },
            react_1.default.createElement(core_1.Typography, { className: classes.headerText, variant: "h3", color: "primary" }, "Save your API Key"),
            react_1.default.createElement(core_1.Typography, { className: classes.headerText, color: "primary" }, "Please make a copy of your API key as it will be shown only once."),
            react_1.default.createElement(core_1.TextField, { className: classes.apiKeyTextField, value: apiKey, disabled: true, variant: "outlined", InputProps: {
                    className: classes.apiKeyTextInput,
                    endAdornment: (react_1.default.createElement(core_1.IconButton, { className: classes.copyButton, onClick: function () {
                            navigator.clipboard
                                .writeText(apiKey)
                                .then(function () {
                                return dispatch(actions_2.default.setSuccessMessage('API Key has been copied to clipboard.'));
                            })
                                .catch(function () {
                                return dispatch(actions_2.default.setErrorMessage('Error copying API Key to clipboard.'));
                            });
                        } },
                        react_1.default.createElement(CopyIcon_1.default, { size: 24, color: "#BBBBBB" }))),
                } }),
            react_1.default.createElement(core_1.Button, { className: classes.copyApiKeyButton, onClick: function () {
                    dispatch(actions_1.default.closeApiKeyModal());
                }, variant: "contained", fullWidth: false }, "Yes, I have copied"))));
};
exports.default = ApiKeyModal;
